import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// Pages autorisées pour le tracking GA
const TRACKED_PAGES = ['/', '/privacy-policy'];

const GA_MEASUREMENT_ID = 'G-T32R0C89ES';

let initialized = false;

export function initAnalytics() {
  if (!initialized) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    initialized = true;
  }
}

/**
 * Hook qui envoie un pageview GA uniquement pour les routes '/' et '/privacy-policy'
 */
export function useAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (TRACKED_PAGES.includes(location.pathname)) {
      initAnalytics();
      ReactGA.send({ hitType: 'pageview', page: location.pathname });
    }
  }, [location.pathname]);
}
